export default function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-force/~/d3-quadtree/src/size.js
// module id = Pp4n
// module chunks = 0